import React from "react";
import Context from "../../../../../../context";
import {
  CustomButton2,
  CustomHourPiker,
  CustomView,
} from "../../../../../../components";
import {
  ICreateAndUpdateSchool,
  IHourTiming,
} from "../../../../../../types/school.interface";
import CustomDropDownSearch from "../../../../../../components/CustomDropDownSearch";
import values from "../../../../../../values";
import { ISchoolGrade } from "../../../../../../types/school.interface";
import { IItem } from "../../../../../../types/common.interface";
import { useTranslation } from "react-i18next";

type Props = {
  defaultValues: ICreateAndUpdateSchool;
  onSubmit: (formData: ICreateAndUpdateSchool) => void;
  onBack: (formData: ICreateAndUpdateSchool) => void;
};

const TimingInformation = (props: Props) => {
  // ** ===========================================================================================================
  // **                                         Values Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const undefinedTime = { hour: undefined, minute: undefined };
  const { isLoading } = React.useContext(Context.SchoolScreen);
  const [timing, setTiming] = React.useState<ISchoolGrade[] | undefined>(
    props.defaultValues.grade ? props.defaultValues.grade : undefined
  );

  // ** ===========================================================================================================
  // **                                          Local Functions
  // ** -----------------------------------------------------------------------------------------------------------
  const updateDepartTime = (newDepartTime: IHourTiming, grade: IItem) => {
    setTiming((prevTiming) => {
      const updatedTiming = prevTiming!.map((item) =>
        item.grade === grade ? { ...item, departTime: newDepartTime } : item
      );
      return updatedTiming;
    });
  };
  const updateEntranceTime = (
    newEntranceTimeTime: IHourTiming,
    grade: IItem
  ) => {
    setTiming((prevTiming) => {
      const updatedTiming = prevTiming!.map((item) =>
        item.grade === grade
          ? { ...item, entranceTime: newEntranceTimeTime }
          : item
      );
      return updatedTiming;
    });
  };

  const { t } = useTranslation();

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  return (
    <CustomView.Container className="create-form-content">
      {!timing && (
        <CustomView.Row className="form-row">
          <CustomView.Column medium={4}>
            <CustomDropDownSearch
              placeHolder={t("selectGrade")}
              itemName="name"
              items={values.dropdownItems.GRADE}
              onSelectItem={(event: IItem) => {
                setTiming(() => [
                  {
                    grade: event,
                    departTime: { hour: "07", minute: "30" },
                    entranceTime: { hour: "13", minute: "00" },
                  },
                ]);
              }}
            />
          </CustomView.Column>
          <CustomView.Column medium={4}>
            <CustomHourPiker
              isNotPiker
              defaultValue={{ hour: "07", minute: "30" }}
              onChange={(event: any) => true}
              inputName={t("enterTime")}
            />
          </CustomView.Column>
          <CustomView.Column medium={4}>
            <CustomHourPiker
              isNotPiker
              defaultValue={{ hour: "13", minute: "00" }}
              onChange={(event: any) => true}
              inputName={t("leaveTime")}
            />
          </CustomView.Column>
        </CustomView.Row>
      )}
      {timing !== undefined && (
        <section>
          {timing.map((time: any) => (
            <CustomView.Row className="form-row">
              <CustomView.Column medium={4}>
                <CustomDropDownSearch
                  defaultItem={time?.grade ? time.grade : undefined}
                  placeHolder={t("selectGrade")}
                  itemName="name"
                  items={values.dropdownItems.GRADE}
                  onSelectItem={(event: IItem) => {
                    if (event === null)
                      setTiming((prevTiming) => prevTiming!.filter((item) => item.grade !== time?.grade));
                    else
                      setTiming((prevTiming) => [
                        ...prevTiming!,
                        {
                          grade: event,
                          entranceTime: { hour: "07", minute: "30" },
                          departTime: { hour: "13", minute: "00" },
                        },
                      ]);
                  }}
                />
              </CustomView.Column>
              <CustomView.Column medium={4}>
                <CustomHourPiker
                  defaultValue={time?.entranceTime ? time.entranceTime : undefined}
                  onChange={(event: any) => updateEntranceTime(event, time.grade)}
                  inputName={t("enterTime")}
                />
              </CustomView.Column>
              <CustomView.Column medium={4}>
                <CustomHourPiker
                  defaultValue={time?.departTime ? time.departTime : undefined}
                  onChange={(event: any) => updateDepartTime(event, time.grade)}
                  inputName={t("leaveTime")}
                />
              </CustomView.Column>
            </CustomView.Row>
          ))}
          <CustomView.Row className="form-row">
            <CustomView.Column medium={4}>
              <CustomDropDownSearch
                placeHolder={t("selectGrade")}
                itemName="name"
                items={values.dropdownItems.GRADE}
                onSelectItem={(event: IItem) => {
                  setTiming((prevTiming) => [
                    ...prevTiming!,
                    {
                      grade: event,
                      departTime: undefinedTime,
                      entranceTime: undefinedTime,
                    },
                  ]);
                }}
              />
            </CustomView.Column>
            <CustomView.Column medium={4}>
              <CustomHourPiker
                isNotPiker
                defaultValue={undefinedTime}
                onChange={(event: any) => true}
                inputName={t("enterTime")}
              />
            </CustomView.Column>
            <CustomView.Column medium={4}>
              <CustomHourPiker
                isNotPiker
                defaultValue={undefinedTime}
                onChange={(event: any) => true}
                inputName={t("leaveTime")}
              />
            </CustomView.Column>
          </CustomView.Row>
        </section>
      )}
      <CustomView.Row className="form-row bottom">
        <CustomView.Column large={3} medium={4} small={6} className="form-colum">
          <CustomButton2
            isLoading={isLoading}
            onClick={() =>
              props.onBack({ ...props.defaultValues, grade: timing })
            }
            title={t("back")}
            type="danger"
          />
        </CustomView.Column>
        <CustomView.Column large={3} medium={4} small={6} className="form-colum">
          <CustomButton2
            isLoading={isLoading}
            onClick={() => props.onSubmit({ ...props.defaultValues, grade: timing })}
            title={t("next")}
          />
        </CustomView.Column>
      </CustomView.Row>
    </CustomView.Container>
  );
};

export default TimingInformation;
